var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    ("" + _vm.cssPrefix),
    'sw-flexbox',
    'sw-flexbox--center-items',
    ( _obj = {}, _obj[(_vm.cssPrefix + "--disabled")] = _vm.disabled, _obj[(_vm.cssPrefix + "--highlight")] = _vm.highlight, _obj ) ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }